import { useCallback } from "react"
import { useNavigate } from "react-router-dom"
import { useActionGuard } from "../../../../hooks/useActionGuard.ts"
import { userHasCommerceRegistration } from "../../../../utils/userCommerces.ts"
import {
  trackMaterialsCommerceSupplierCtaClick,
  type MaterialsQuotationFlow,
} from "../../../../utils/analytics/materialsQuotationFunnelAnalytics.ts"
import styles from "./MaterialsCommerceSupplierCta.module.scss"

type MaterialsCommerceSupplierCtaProps = {
  userData: unknown
  flow: MaterialsQuotationFlow
  edifyUserId?: string
}

const MaterialsCommerceSupplierCta = ({
  userData,
  flow,
  edifyUserId = "",
}: MaterialsCommerceSupplierCtaProps) => {
  const navigate = useNavigate()
  const { guard } = useActionGuard()
  const hasCommerce = userHasCommerceRegistration(userData)

  const goToCommerceAlta = useCallback(() => {
    trackMaterialsCommerceSupplierCtaClick(edifyUserId, flow, "browse_panel", "alta")
    guard("register_commerce", () => navigate("/comercios/alta"))()
  }, [edifyUserId, flow, guard, navigate])

  const goToCommerceCatalog = useCallback(() => {
    trackMaterialsCommerceSupplierCtaClick(edifyUserId, flow, "browse_panel", "catalogo")
    guard("register_commerce", () => navigate("/comercios/lista-precios"))()
  }, [edifyUserId, flow, guard, navigate])

  if (hasCommerce) {
    return (
      <p className={styles.supplierLine} role="note">
        ¿Tenés comercio en Edify?{" "}
        <button type="button" className={styles.supplierLink} onClick={goToCommerceCatalog}>
          Actualizá tu catálogo de materiales
        </button>{" "}
        para aparecer cuando alguien cotice en tu zona.
      </p>
    )
  }

  return (
    <p className={styles.supplierLine} role="note">
      ¿Vendés materiales?{" "}
      <button type="button" className={styles.supplierLink} onClick={goToCommerceAlta}>
        Registrá tu comercio
      </button>{" "}
      y subí tu catálogo para recibir pedidos en tu zona.
    </p>
  )
}

export default MaterialsCommerceSupplierCta
